<template>
    <div class="max-w-2xl space-y-4">
        <p class="text-sm uppercase tracking-[0.3em] text-gray-500">Journal</p>
        <h1
            class="text-4xl md:text-6xl font-semibold tracking-tight text-gray-900"
        >
            Blog
        </h1>
        <p class="text-lg text-gray-600 leading-8">
            Scheduling advice, booking workflows, and practical lessons for
            teams and service businesses.
        </p>
    </div>
</template>
